// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavBar-module--menu--2KLmF","link":"NavBar-module--link--yJ_Jz","active":"NavBar-module--active--RJu3Y","logo":"NavBar-module--logo--3TZSM"};